import ServiceBase from './ServiceBase';
import ValidateCodeModal from "@/components/ValidateCodeModal.vue";
import Vue from 'vue';

const ValidateCodeModalConstractor = Vue.extend(ValidateCodeModal);

class CodeService extends ServiceBase {
    sendSmsCode(mobile, type) {
        let that = this;
        return new Promise((resolve) => {
            let flag = this.store.state.commonSetting.is_send_sms;
            async function send(code, key, errorCallback) {
                let config = {};
                if (flag == 1) {
                    config.onError = (data) => {
                        errorCallback && errorCallback(data);
                    };
                }
                await that.http.post("/api/app/smsCode", {
                    mobile: mobile,
                    sms_type: type,
                    captcha: code,
                    key
                }, config);
                that.vue.$message({
                    message: "验证码已成功发送！",
                    type: "success",
                });
                resolve();
            }
            if (flag == 1) {
                let instance = new ValidateCodeModalConstractor();
                instance.visible = true;
                instance.cloedHanlder = () => {
                    document.body.removeChild(instance.$el);
                };
                instance.confirmHandler = async ({ code, key }) => {
                    await send(code, key, error => {
                        if (error.msg == "图形验证码错误，请重新输入") {
                            instance.getImgCode();
                            instance.error = "图形验证码错误，请重新输入";
                        } else {
                            this.vue.$message.error(error.msg);
                        }
                    });
                    instance.visible = false;
                };
                instance.$mount();
                document.body.appendChild(instance.$el);
            } else {
                send();
            }
        });
    }
}

export default () => {
    return new CodeService();
}